export const Endpoints = {
    imageEndpoint: '/api/Badge',
    currentBadgePhotoEndpoint: '/api/Badge/currentphoto',
    userEndpoint: '/api/User',
    smsCountryCodesEndpoint: 'api/ref/smscountrycodes',
    passcodeEmailEndpoint: '/api/PassCode/email',
    passcodeSmsEndpoint: '/api/PassCode/sms',
    passcodeIsValidEndpoint: '/api/PassCode/isvalid',
    versionEndpoint: '/api/Verification/version',
}
